// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"G_bR","view":"G_cB","slide":"G_bT","img":"G_cC","btn":"G_bF","right":"G_cD","indicators":"G_cF","indicator":"G_cG","active":"G_cb"};